import React, { useMemo, useState } from "react";

import {
  RideButton,
  RideGlDownloadSolid,
} from "@rimac-seguros/ride-system-components";
import { useSelector } from "react-redux";

import { usePlanService } from "@/services/plan.service";
import { usePlansContext } from "../../../context/PlansContext";
import { decryptCredentials } from "@/utils/cifrate";
import helpers from "@/utils/helpers";
import { currencyFormat } from "@/utils/currency";
import { APP_KEY_ENCRYPT } from "@/utils/awsConfig";
import { encrypt_AES256_2 } from "@/utils/CryptographyUtils";

export const DownloadQuote = () => {
  const [loading, setLoading] = useState(false);

  const userData = useSelector((state) => state.vida.userData);
  const { typeOfFinancing, planSelected, nameFrequency } = useSelector(
    (state) => state.plans,
  );
  const { devolucionTotal, pagoMensual, aporteTotal, gananciaTotal } =
    typeOfFinancing || {};
  const { sumAssured, savingTime, returnPercentage } = planSelected || {};

  const { downloadQuote } = usePlanService();
  const { isLoadingData } = usePlansContext();

  const handleDownload = async () => {
    setLoading(true);
    helpers.getTagAction(
      "Seguro Vida Devolución Garantizada",
      "Cotización",
      "click",
      "Descargar tu cotización - B",
      "trackAction",
    );

    try {
      const request = {
        ideCotizacion: planSelected.ideTransaccion,
        idPlantilla: decryptCredentials(process.env.REACT_APP_KEY_TEMPLATE_PDF),
        producto: "vcd",
        dimensiones: {
          width: "1008px",
          height: "1440px",
        },
        data: {
          cliente: {
            nombre: getFullName,
            celular: userData?.telefono || userData?.celular || "-",
            correo: userData?.correo || userData?.email || "-",
            numero_documento:
              userData?.numeroDocumento || userData?.documento || "-",
          },
          plan: {
            pago_mensual: `S/${currencyFormat(pagoMensual || 0)}`,
            devolucion_total: `S/${currencyFormat(devolucionTotal || 0)}`,
            ganancia_extra: `S/${currencyFormat(gananciaTotal || 0)}`,
            aporte_total: `S/${currencyFormat(aporteTotal || 0)}`,
            cobertura_fallec: sumAssured?.text,
            tiempo_ahorro: `${savingTime?.text} años`,
            porcentaje_devolucion: returnPercentage?.text,
            frecuencia_pago: nameFrequency
              ? nameFrequency.charAt(0).toUpperCase() +
                nameFrequency.slice(1).toLowerCase()
              : "",
          },
        },
      };

      const { payload } = await downloadQuote(request);
      const url = payload?.fileUrl;

      if (userData.indPrevPageApp) {
        const message = `EMBEDDED-APP-HIPERVINCULO : {"accion": "PDF" , "valor": "${url}" , "mensaje": "", "titulo": "Cotización Seguro Vida Ahorro con Devolución"}`;
        const encryptedMessage = encrypt_AES256_2(message, APP_KEY_ENCRYPT);
        return helpers.sendMessageToApp(encryptedMessage);
      }
      const link = document.createElement("a");
      link.href = url;
      link.download = payload?.fileUrl?.split("Digital/")[1];
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getFullName = useMemo(() => {
    const { nombres, apellidoPaterno, apellidoMaterno } = userData;
    return nombres
      ? `${helpers.capitalizeFullName(nombres)} ${helpers.capitalizeFullName(
          apellidoPaterno,
        )} ${helpers.capitalizeFullName(apellidoMaterno)}`
      : "";
  }, [userData]);

  return (
    <div className="pt-ride-gl-spacing-4xlarge">
      <RideButton
        text="Descarga tu cotización"
        variant="text-primary"
        size="medium"
        disabled={isLoadingData || loading}
        glyph={<RideGlDownloadSolid />}
        glyphPosition="right"
        className="w-full"
        onClick={handleDownload}
      />
    </div>
  );
};
